import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '../business-loan/button/button.component';
import { BusinessLoanModule } from '../business-loan/business-loan.module';
import { VerifyEmailComponent } from './verify-email/verify-email.component';

@NgModule({
  declarations: [VerifyEmailComponent],
  imports: [CommonModule, RouterModule, BusinessLoanModule, ButtonComponent],
  exports: [VerifyEmailComponent],
})
export class VerifyEmailModule {}

